export default __webpack_public_path__ + "static/media/dao_treasury_investments_page_icon.38b99082.svg";